export { RENDERER_TYPE, textRenderer } from "./textRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/textRenderer/index.mjs
// module id = 168
// module chunks = 1